import CardHolderPanel from "modules/CardHolders/components/CardHolderPanel.Container/CardHolderPanel.Container";

function CorporateCardHolderPanelPage() {
  return <CardHolderPanel cardType={"corporate"} />;
}

export default CorporateCardHolderPanelPage;
